import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { Differentiator } from '../components/Differentiator';
import { PricingSection } from '../components/PricingSection';
import { ComparisonTable } from '../components/ComparisonTable';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-100 selection:text-brand-900" data-id="element-447">
      <Navbar data-id="element-448" />
      <main data-id="element-449">
        <Hero data-id="element-450" />
        <ProblemSection data-id="element-451" />
        <HowItWorks data-id="element-452" />
        <Differentiator data-id="element-453" />
        <PricingSection data-id="element-454" />
        <ComparisonTable data-id="element-455" />
        <FinalCTA data-id="element-456" />
      </main>
      <Footer data-id="element-457" />
    </div>;
}